// Surface primitive — one card, tone + elevation via props (never nested
// bordered boxes). tone: surface (default) | surface-2. flush removes padding
// for lists/media. raised bumps to elev-2.
export function Card({ tone = "surface", flush = false, raised = false, className = "", style, children, ...rest }) {
  const cls = [
    "bz-card",
    tone === "surface-2" && "bz-card--2",
    flush && "bz-card--flush",
    raised && "bz-card--raised",
    className,
  ].filter(Boolean).join(" ");
  return <div className={cls} style={style} {...rest}>{children}</div>;
}
